"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FU_ERROR_MESSAGES = exports.UPLOAD_TIMEOUT_MS = exports.UPLOAD_CHUNK_SIZE = void 0;
exports.buildFuSendArgs = buildFuSendArgs;
exports.buildSuUploadParams = buildSuUploadParams;
exports.buildFuWirePayload = buildFuWirePayload;
exports.buildSuWirePayload = buildSuWirePayload;
exports.resolveUploadSessionKey = resolveUploadSessionKey;
exports.mapUploadErrorMessage = mapUploadErrorMessage;
exports.writeTcpChunkedFileUpload = writeTcpChunkedFileUpload;
exports.sendBrowserTwoMessageFileUpload = sendBrowserTwoMessageFileUpload;
exports.sendWsChunkedFileUpload = sendWsChunkedFileUpload;
exports.encodeSuUploadHeader = encodeSuUploadHeader;
const utils_1 = require("../utils");
const appFrame_1 = require("./appFrame");
/** Размер чанка бинарной загрузки (`su`) — как в Android / reproduce_upload. */
exports.UPLOAD_CHUNK_SIZE = 65536;
exports.UPLOAD_TIMEOUT_MS = 60000;
exports.FU_ERROR_MESSAGES = {
    5: 'Сервер отказал в загрузке файла',
    6: 'Файл слишком большой (лимит 192 МБ)',
    7: 'Этот тип файла запрещён для загрузки',
    8: 'Файл заблокирован политикой безопасности',
};
/** Аргументы для `transport.send('fu', args)`. */
function buildFuSendArgs(fileName, fileSize, fileMd5, isQms = false) {
    const args = [fileName, fileSize, fileMd5];
    if (isQms)
        args.push(1);
    return args;
}
/** Параметры для `transport.upload('su', params, fileData)`. */
function buildSuUploadParams(sessionKey, fileName, fileSize, fileMd5, isQms = false) {
    const params = [sessionKey, 'fu', fileName, fileSize, fileMd5];
    if (isQms)
        params.push(1);
    return params;
}
/** Payload с явным request id (standalone WS без ITransport). */
function buildFuWirePayload(reqId, fileName, fileSize, fileMd5, isQms = false) {
    const payload = [reqId, 'fu', fileName, fileSize, fileMd5];
    if (isQms)
        payload.push(1);
    return payload;
}
function buildSuWirePayload(reqId, sessionKey, fileName, fileSize, fileMd5, isQms = false) {
    const payload = [reqId, 'su', sessionKey, 'fu', fileName, fileSize, fileMd5];
    if (isQms)
        payload.push(1);
    return payload;
}
function resolveUploadSessionKey(serverData, memberId) {
    let candidate = serverData;
    if (Array.isArray(candidate)) {
        candidate = candidate[0];
    }
    if (typeof candidate === 'string' && candidate.startsWith('att-')) {
        return candidate;
    }
    const id = String(memberId);
    const randomInt = Math.floor(Math.random() * 8192) + 65536;
    return `att-${id}-${randomInt}`;
}
function mapUploadErrorMessage(message) {
    const fuMatch = message.match(/fu failed: status=(\d+)/);
    if (fuMatch) {
        const code = Number(fuMatch[1]);
        return exports.FU_ERROR_MESSAGES[code] ?? `Ошибка инициализации загрузки (код ${code})`;
    }
    const suMatch = message.match(/su failed: status=(\d+)/);
    if (suMatch) {
        const code = Number(suMatch[1]);
        return exports.FU_ERROR_MESSAGES[code] ?? `Ошибка передачи файла (код ${code})`;
    }
    return message;
}
function sendWsFrame(ws, data, options) {
    return new Promise((resolve, reject) => {
        ws.send(data, options, (err) => {
            if (err)
                reject(err instanceof Error ? err : new Error(String(err)));
            else
                resolve();
        });
    });
}
/** TCP :993 — фрагментированный `su` (как официальный Android-клиент). */
function writeTcpChunkedFileUpload(write, suWirePayload, fileData, onProgress) {
    const header = (0, appFrame_1.encodeDocument)(suWirePayload);
    write((0, appFrame_1.encodeWsFrame)(header, { opcode: appFrame_1.OPCODE_TEXT, fin: false }));
    let offset = 0;
    const totalSize = fileData.length;
    while (offset < totalSize) {
        const length = Math.min(exports.UPLOAD_CHUNK_SIZE, totalSize - offset);
        const chunk = Buffer.from(fileData.subarray(offset, offset + length));
        offset += length;
        const isFin = offset >= totalSize;
        write((0, appFrame_1.encodeWsFrame)(chunk, { opcode: appFrame_1.OPCODE_CONTINUATION, fin: isFin }));
        onProgress?.(Math.round((offset / totalSize) * 100));
    }
}
/** Browser fallback: два полных WS-сообщения (header FIN + body FIN), без фрагментации. */
async function sendBrowserTwoMessageFileUpload(send, suWirePayload, fileData) {
    const header = (0, utils_1.encodePdaJson)(suWirePayload);
    await send(header, false);
    await send(fileData, true);
}
/** WebSocket API (`ws` npm): Win1251 JSON + binary-чанки с `fin` на последнем. */
async function sendWsChunkedFileUpload(ws, suWirePayload, fileData, onProgress) {
    const header = (0, utils_1.encodePdaJson)(suWirePayload);
    await sendWsFrame(ws, header, { fin: false });
    let offset = 0;
    const totalSize = fileData.length;
    while (offset < totalSize) {
        const length = Math.min(exports.UPLOAD_CHUNK_SIZE, totalSize - offset);
        const chunk = fileData.subarray(offset, offset + length);
        offset += length;
        const isFin = offset >= totalSize;
        await sendWsFrame(ws, chunk, { fin: isFin, binary: true });
        onProgress?.(Math.round((offset / totalSize) * 100));
    }
}
/** Заголовок `su` для transport.upload (id добавляется снаружи). */
function encodeSuUploadHeader(requestId, params) {
    return (0, utils_1.encodePdaJson)([requestId, 'su', ...params]);
}
